// extracted by mini-css-extract-plugin
export var container = "_n6-0";
export var dotAnimation = "_n6-2";
export var dotsLoading = "_n6-1";